import React, { useEffect } from "react";
import Header from "../../components/Header/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import s from "./Participants.module.scss";
import { Table } from "antd";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../../../components/WindowDimensions/WindowDimensions";
import PageTitle from "../../components/PageTitle/PageTitle";
import BackLink from "../../components/BackLink/BackLink";

const columns = [
  {
    title: "№",
    dataIndex: "number",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: `Country`,
    dataIndex: "country",
  },
];

const Participants = () => {
  const { id } = useParams();
  const participants = useSelector((state) => state.landing.participants);
  const width = useWindowDimensions();

  return (
    <div>
      {width > 1200 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}

      <div className={s.content}>
        <div className={s.link}>
          <BackLink fallback={`/events/${id}`}>Back to Event</BackLink>
        </div>
        <PageTitle className={s.h2} eyebrow="Event" title="List of participants" />
        <div className={s.table}>
          <Table
            bordered
            pagination={false}
            columns={columns}
            dataSource={participants?.map((it, index) => ({
              number: <div className={s.td}>{index + 1}</div>,
              name: <div className={s.td}>{it?.name}</div>,
              country: <div className={s.td}>{it?.country}</div>,
            }))}
          />
        </div>
      </div>
      <LandingFooter />
      <ScrollToTop />
    </div>
  );
};

export default Participants;
